"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utilityConfiguration = require("@emcm-ui/utility-configuration");

var _utilityConfiguration2 = _interopRequireDefault(_utilityConfiguration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (displayName) {
  if (_utilityConfiguration2.default.current.styles.namespace) {
    return _utilityConfiguration2.default.current.styles.namespace + "-" + displayName;
  }

  return displayName;
};